var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppLinearProgressBar',{staticClass:"quiz-progress-bar",attrs:{"color":"#EE7F1A","value":_vm.value,"background-color":"#edf3f9"}})
}
var staticRenderFns = []

export { render, staticRenderFns }